import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.hte.sn';

export const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    return response.data;
  },
  
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
  
  refreshToken: async () => {
    const response = await api.post('/auth/refresh');
    return response.data;
  }
};
// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // window.location.href = '/login';
      window.location.replace('/login');

    }
    return Promise.reject(error);
  }
);

export const dashboardService = {

  getSummary: (period = '7days') => api.get(`/dashboard/summary?period=${period}`),
  getStats: () => api.get('/dashboard/stats'),
  getRecentTransactions: (limit = 5) => api.get(`/dashboard/recent-transactions?limit=${limit}`),
  getRevenueChart: (period = '7days') => api.get(`/dashboard/revenue-chart?period=${period}`),
  // 💧⚡ Graphiques par type de compteur : utility = 'all' | 'electricity' | 'water'
  getUtilityCharts: (period = '7days', utility = 'all') =>
    api.get('/dashboard/utility-charts', { params: { period, utility } }),
  getKwhChart: (period = '7days') => api.get(`/dashboard/kwh-chart?period=${period}`), // ✅ NOUVEAU
  getTopCustomers: (limit = 5) => api.get(`/dashboard/top-customers?limit=${limit}`),
  getAlertsSummary: () => api.get('/dashboard/alerts-summary'),
  getMetersByZone: () => api.get('/dashboard/meters-by-zone'),
  getCo2Chart: (period = '7days') => api.get(`/dashboard/co2-chart?period=${period}`), // ✅ NOUVEAU
  getEnvironmentalImpactSummary: (params) =>
  api.get('/dashboard/environmental-impact/summary', { params }),
  exportEnvironmentalImpactXlsx: (params) =>
  api.get('/dashboard/environmental-impact/export-xlsx', { params, responseType: 'blob' }),
  getMetersByProfession: (params) =>
    api.get('/dashboard/meters-by-profession', { params }),
  // ✅ MODIFIÉ : accepte maintenant { month, year } pour filtrer un mois précis
  getMetersByAddress: (params = {}) => {
    const query = new URLSearchParams();
    if (params.month) query.set('month', params.month);
    if (params.year) query.set('year', params.year);
    const qs = query.toString();
    return api.get(`/dashboard/meters-by-address${qs ? `?${qs}` : ''}`);
  },

  // // ✅ NOUVELLE MÉTHODE: Export Impact Environnemental
  // exportEnvironmentalImpactXlsx: () => api.get('/dashboard/environmental-impact/export-xlsx', {
  //   responseType: 'blob'
  // }),

  // ✅ MODIFIÉ : accepte { month, year, address } pour filtrer l'export
  exportVillagesXlsx: (params = {}) => {
    const query = new URLSearchParams({ format: 'xlsx' });
    if (params.month) query.set('month', params.month);
    if (params.year) query.set('year', params.year);
    if (params.address) query.set('address', params.address);
    return api.get(`/dashboard/meters-by-address/export?${query.toString()}`, {
      responseType: 'blob'
    });
  },

  exportVillagesPdf: (params = {}) => {
    const query = new URLSearchParams({ format: 'pdf' });
    if (params.month) query.set('month', params.month);
    if (params.year) query.set('year', params.year);
    if (params.address) query.set('address', params.address);
    return api.get(`/dashboard/meters-by-address/export?${query.toString()}`, {
      responseType: 'blob'
    });
  },

};
export const metersService = {
  getAll: (params = {}) => api.get('/meters', { params }),
  getById: (id) => api.get(`/meters/${id}`),
  create: (data) => api.post('/meters', data),
  update: (id, data) => api.put(`/meters/${id}`, data),
  delete: (id) => api.delete(`/meters/${id}`),
  getStats: () => api.get('/meters/stats/overview'),
    
   // ✅ HISTORIQUE DES OPÉRATIONS AVANCÉES
  getHistory: (params = '') => api.get(`/advanced/history?${params}`),
  getHistoryDetail: (operationId) => api.get(`/advanced/history/${operationId}`),
  getHistoryStats: () => api.get('/advanced/history/stats/summary'),

  // ✅ NOUVEAU: Récupérer les adresses uniques
  getUniqueAddresses: () => api.get('/meters/unique-addresses'),
  
  // Actions de configuration
  clearCredit: (meterId) => api.post(`/advanced/clear-credit/${meterId}`),
  clearTamper: (meterId) => api.post(`/advanced/clear-tamper/${meterId}`),
  setPowerLimit: (meterId, limit) => api.post(`/advanced/set-power-limit/${meterId}`, null, { params: { power_limit: limit } }),
  setMaxDaily: (meterId, max) => api.post(`/advanced/set-max-daily/${meterId}`, null, { params: { max_kwh: max } }),
  
  // ✅ NOUVEAUX: Blocage/Déblocage
  block: (meterId) => api.post(`/meters/${meterId}/block`),
  unblock: (meterId) => api.post(`/meters/${meterId}/unblock`),
  manualBlock: (meterId, reason) => api.post(`/meters/${meterId}/manual-block`, { reason }),
  manualUnblock: (meterId) => api.post(`/meters/${meterId}/manual-unblock`),
  // dans metersService
  getUniqueProfessions: () => api.get('/meters/unique-professions'),
  getGomelongSgcList: (meterId) => api.get(`/advanced/gomelong/sgc-list/${meterId}`),
  setGomelongSgc: (meterId, sgcId, reason) =>
      api.post(`/advanced/gomelong/set-sgc/${meterId}`, null, { params: { sgc_id: sgcId, reason } }),
      // ✅ NOUVEAUX : endpoints STRON complémentaires
  queryMeterCredit: (meterId) => api.get(`/advanced/query-meter-credit/${meterId}`),
  queryCustomerCredit: (customerId) => api.get(`/advanced/query-customer-credit/${customerId}`),
  queryCustomerInfo: (customerId) => api.get(`/advanced/query-customer-info/${customerId}`),
  remotelyRead: (meterId) => api.get(`/advanced/remotely-read/${meterId}`),
  switchToPrepaid: (meterId, customerId, reason) =>
    api.post(`/advanced/switch-to-prepaid/${meterId}`, null, {
      params: { customer_id: customerId, reason }
    }),
  switchToPostpaid: (meterId, customerId, reason) =>
    api.post(`/advanced/switch-to-postpaid/${meterId}`, null, {
      params: { customer_id: customerId, reason }
    }),
  queryDailyConsumption: (meterId, date, phaseType = 'single') =>
    api.get(`/advanced/query-daily-consumption/${meterId}`, {
      params: { date, phase_type: phaseType }
    }),
    
  vendingSendToken: (meterId, token) =>
    api.post(`/advanced/vending-send-token/${meterId}`, null, {
      params: { token }
    }),
  queryConcentratorInfo: (concentratorId) =>
    api.get(`/advanced/query-concentrator-info/${concentratorId}`),

  getMeterCreditHistoryLocal: (meterId) => 
    api.get(`/advanced/meter-credit-history/${meterId}`),
  clearCreditRemotely: (meterId, customerId, reason) =>
    api.post(`/advanced/clear-credit-remotely/${meterId}`, null, {
      params: { customer_id: customerId, reason }
    }),
  clearTamperRemotely: (meterId, customerId, reason) =>
    api.post(`/advanced/clear-tamper-remotely/${meterId}`, null, {
      params: { customer_id: customerId, reason }
    }),
  remotelySetConcentrator: (concentratorId, reason) =>
    api.post(`/advanced/remotely-set-concentrator/${concentratorId}`, null, {
      params: { reason }
    }),
  vendingMeterRemotely: (meterId, amount, isVendByUnit = true, reason) =>
    api.post(`/advanced/vending-meter-remotely/${meterId}`, null, {
      params: { amount, is_vend_by_unit: isVendByUnit, reason }
    }),

  updateAmiMeter: (meterId, concentratorId, meterType = 1, customerId = '') =>
    api.post(`/advanced/update-ami-meter/${meterId}`, null, {
      params: { concentrator_id: concentratorId, meter_type: meterType, customer_id: customerId }
    }),
  getMeterConcentrator: (meterId) =>
    api.get(`/advanced/meter-concentrator/${meterId}`),

  getMeterFullInfo: (meterId) => api.get(`/advanced/meter-full-info/${meterId}`),
  blockMeterRemote: (meterId, reason) =>
    api.post(`/advanced/block-meter/${meterId}`, null, { params: { reason } }),
 
  unblockMeterRemote: (meterId, reason) =>
    api.post(`/advanced/unblock-meter/${meterId}`, null, { params: { reason } }),

  
  // ✅ NOUVEAUX: Blocage/Déblocage
  block: (meterId) => api.post(`/meters/${meterId}/block`),
  unblock: (meterId) => api.post(`/meters/${meterId}/unblock`),
  getDecoderKey: (meterId) => 
      api.get(`/advanced/get-decoder-key/${meterId}`),
    
  setDecoderKey: (meterId, newDecoderKey) => 
    api.post(`/advanced/set-decoder-key/${meterId}`, null, {
      params: { new_decoder_key: newDecoderKey }
    }),  
     manualBlock: (meterId, reason = '') => 
        api.post(`/meters/${meterId}/manual-block`, { reason }),
    
    manualUnblock: (meterId) => 
        api.post(`/meters/${meterId}/manual-unblock`), 
  
};



export const customersService = {
  getAll: (params = {}) => api.get('/customers', { params }),
  getById: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  // delete: (id) => api.delete(`/customers/${id}`),
  toggleBlock: (id) => api.post(`/customers/${id}/toggle-block`),
  // sendSMS: (id, message) => api.post(`/customers/${id}/send-sms`, { message }),
   // Nouvelle méthode de suppression avec paramètre force
  delete: (customerId, force = false) => 
    api.delete(`/customers/${customerId}${force ? '?force=true' : ''}`),
  
  // Garder l'ancienne pour compatibilité
  deletePermanent: (customerId) => 
    api.delete(`/customers/${customerId}/permanent`),
  // Dans customersService, ajoutez :
  search: (query = '', limit = 50) => api.get(`/customers/search`, {
    params: { q: query, limit }

    }),
    // ✅ NOUVEAU: SMS individuel
  sendSMS: (customerId, message) => 
    api.post(`/customers/${customerId}/send-sms`, { message }),
  
  // ✅ NOUVEAU: SMS groupé
  sendBulkSMS: (data) => 
    api.post('/customers/send-bulk-sms', data),

   /**
   * Bloque tous les clients actifs
   */
  blockAll: (reason = 'Blocage administratif en masse') => 
    api.post('/customers/bulk-block', { 
      block_all: true, 
      reason 
    }),
  
  /**
   * Débloque tous les clients bloqués
   */
  unblockAll: (reason = 'Déblocage administratif en masse') => 
    api.post('/customers/bulk-unblock', { 
      unblock_all: true, 
      reason 
    }),
  
  /**
   * Bloque une liste spécifique de clients
   */
  blockSelected: (customerIds, reason = 'Blocage administratif') => 
    api.post('/customers/bulk-block', { 
      customer_ids: customerIds, 
      reason 
    }),
  
  /**
   * Débloque une liste spécifique de clients
   */
  unblockSelected: (customerIds, reason = 'Déblocage administratif') => 
    api.post('/customers/bulk-unblock', { 
      customer_ids: customerIds, 
      reason 
    }),
  
  /**
   * Prévisualise le blocage en masse (combien de clients seront affectés)
   */
  previewBlockAll: () => 
    api.get('/customers/bulk-block/preview'),
  
  /**
   * Prévisualise le déblocage en masse (combien de clients seront affectés)
   */
  previewUnblockAll: () => 
    api.get('/customers/bulk-unblock/preview'),
};

export const transactionsService = {
  getAll: (params = {}) => api.get('/transactions/', { params }),
  getById: (id) => api.get(`/transactions/${id}`),
  create: (data) => api.post('/transactions/', data),
  complete: (id, wave_txn_id) => api.post(`/transactions/${id}/complete`, { wave_transaction_id: wave_txn_id }),
  refund: (id) => api.post(`/transactions/${id}/refund`),
  getStats: () => api.get('/transactions/stats/overview'),
  
  
  // ✅ NOUVEAU : Paiement Wave depuis la plateforme
  createWavePayment: (data) => api.post('/transactions/wave/create-payment', data),
  
  // ✅ NOUVEAU : Vérifier statut paiement Wave
  checkWavePayment: (checkoutId) => api.get(`/transactions/wave/check-payment/${checkoutId}`),
  
  // ✅ NOUVEAU : Annuler paiement Wave
  cancelWavePayment: (checkoutId) => api.post(`/transactions/wave/cancel-payment/${checkoutId}`),

  
};

export const usersService = {
  // Récupérer tous les utilisateurs
  getAll: (params = {}) => api.get('/users', { params }),

  
  
  // Créer un utilisateur
  create: (data) => api.post('/users', data),
  
  // Mettre à jour un utilisateur (pour l'admin)
  update: (id, data) => api.put(`/users/${id}`, data),
  
  // Supprimer un utilisateur
  delete: (id) => api.delete(`/users/${id}`),
  
  // Activer/Désactiver un utilisateur
  toggleActive: (id) => api.post(`/users/${id}/toggle-active`),
  
  // Exporter les utilisateurs en CSV
  exportCSV: () => api.get('/import-export/users/export', { responseType: 'blob' }),
  
  // ✅ Changer le mot de passe (utilisateur connecté)
  changePassword: (oldPassword, newPassword) => 
    api.post('/users/change-password', { oldPassword, newPassword }),
  
  // ✅ Mettre à jour le profil d'un utilisateur
  updateProfile: (id, data) => api.put(`/users/profile/${id}`, data),
  
  // ✅ Récupérer les permissions d'un utilisateur
  getPermissions: (id) => api.get(`/users/${id}/permissions`),
  
  // ✅ Mettre à jour les permissions d'un utilisateur
  updatePermissions: (id, permissions) => 
    api.put(`/users/${id}/permissions`, { permissions }),
  
  // ✅ Réinitialiser les permissions aux valeurs par défaut du rôle
  resetPermissions: (id) => api.post(`/users/${id}/permissions/reset`),
};

export const monthlyFeesService = {
  // ✅ NOUVEAU: Récupération consolidée (une ligne par client)
  getConsolidated: (params = {}) => api.get('/monthly-fees/consolidated', { params }),
  
  // Récupération standard (détails par mois)
  getAll: (params = {}) => api.get('/monthly-fees/', { params }),
  getById: (feeId) => api.get(`/monthly-fees/${feeId}`),
  getStats: () => api.get('/monthly-fees/stats/summary'),
  
  // Paiement
  recordPayment: (data) => api.post('/monthly-fees/record-payment', data),
  
  // SMS
  sendReminders: () => api.post('/monthly-fees/send-reminders'),
  sendCustomMessage: (feeId, message) => api.post(`/monthly-fees/${feeId}/send-custom-message`, { 
    fee_id: feeId, 
    message 
  }),
  sendGroupSMS: (data) => api.post('/monthly-fees/send-group-sms', data),
  
  // Import/Export
  importExcel: (formData) => api.post('/monthly-fees/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  
  // Suppression
  deleteUnpaid: () => api.delete('/monthly-fees/delete-unpaid'),
  deleteRecentImport: (hours = 24) => api.delete(`/monthly-fees/delete-recent-import?hours=${hours}`),
  
  // Génération
  generateFees: (month, year) => api.post('/monthly-fees/generate', null, { 
    params: { month, year } 
  }),
  checkOverdue: () => api.post('/monthly-fees/check-overdue'),
  
  // Utilitaires
  checkDebt: (meterId) => api.get(`/transactions/check-debt/${meterId}`),
};
export const monitoringService = {
  getDashboard: () => api.get('/advanced/monitoring/dashboard'),

  // ✅ SMS depuis monitoring
  sendMonitoringSMS: (customerId, message) =>
    api.post(`/advanced/monitoring/send-sms/${customerId}`, { message }),

  // ✅ SMS groupé monitoring
  sendMonitoringBulkSMS: (data) =>
    api.post('/advanced/monitoring/send-bulk-sms', data),

  // ✅ CORRIGÉ : Ajout meterSearch pour recherche par numéro de compteur
  getCustomersByRisk: (riskLevel = null, limit = 50, offset = 0, search = null, sortBy = 'risk', meterSearch = null) => {
    // Nettoyer les valeurs vides/nulles
    const cleanSearch      = (search && search.trim())      ? search.trim()      : null;
    const cleanMeterSearch = (meterSearch && meterSearch.trim()) ? meterSearch.trim() : null;
    const cleanRiskLevel   = (riskLevel && riskLevel !== 'all') ? riskLevel       : null;
    const cleanSortBy      = sortBy || 'risk';

    const params = new URLSearchParams();

    if (cleanRiskLevel)   params.append('risk_level',    cleanRiskLevel);
    params.append('limit',    limit.toString());
    params.append('offset',   offset.toString());
    params.append('sort_by',  cleanSortBy);

    // ✅ search OU meter_search — jamais les deux en même temps
    if (cleanMeterSearch) {
      params.append('meter_search', cleanMeterSearch);
    } else if (cleanSearch) {
      params.append('search', cleanSearch);
    }

    const url = `/advanced/monitoring/customers?${params.toString()}`;
    console.log('📡 Monitoring URL:', url);

    return api.get(url);
  },

  updateScores: () => api.post('/advanced/monitoring/update-scores'),
  blockInactive: (days) => api.post('/advanced/monitoring/block-inactive', null, {
    params: { days_threshold: days }
  }),
  getCustomerScore: (customerId) => api.get(`/advanced/monitoring/customer/${customerId}/score`),

  // Routes système
  getSystemDashboard:  () => api.get('/monitoring/dashboard'),
  applyBlocking:       () => api.post('/monitoring/apply-preventive-blocking'),
  updateRiskScores:    () => api.post('/monitoring/update-risk-scores'),
  getInactiveClients:  (days) => api.get('/monitoring/inactive-clients', { params: { days } })
};
export const accountingService = {
  // Dépenses
  getExpenses: (params = {}) => api.get('/accounting/expenses', { params }),
  createExpense: (data) => api.post('/accounting/expenses', data),
  updateExpense: (id, data) => api.put(`/accounting/expenses/${id}`, data),
  deleteExpense: (id) => api.delete(`/accounting/expenses/${id}`),

  // Stats
  getStats: (year) => api.get('/accounting/stats', { params: { year } }),

  // Exports
  exportExcel: (year) => api.get('/accounting/expenses/export-xlsx', {
    params: { year },
    responseType: 'blob'
  }),
  exportPDF: (year) => api.get('/accounting/expenses/export-pdf', {
    params: { year },
    responseType: 'blob'
  }),

};
// ============================================
// ALERTS (ALERTES) - ✅ COMPLET
// ============================================
export const alertsService = {
  // Récupération des alertes
  getAll: (params = {}) => api.get('/alerts', { params }),
  getById: (id) => api.get(`/alerts/${id}`),  // ✅ FIX: Backticks
  getUnreadCount: () => api.get('/alerts/unread-count'),
  getStats: () => api.get('/alerts/stats'),
  getCount: (params = {}) => api.get('/alerts/count', { params }),  // ✅ NOUVEAU
  
  // Actions sur les alertes
  markAsRead: (id) => api.put(`/alerts/${id}/mark-read`),  // ✅ FIX: Backticks
  markAllAsRead: () => api.post('/alerts/mark-all-read'),
  delete: (id) => api.delete(`/alerts/${id}`),  // ✅ FIX: Backticks
  
  // Vérifications individuelles par type
  checkInactiveMeters: (months = 3) => 
    api.post('/alerts/check-inactive-meters', null, { params: { months } }),
  
  checkLowCredit: (threshold = 1000) => 
    api.post('/alerts/check-low-credit', null, { params: { threshold } }),
  
  checkTamperAlerts: () => 
    api.post('/alerts/check-tamper-alerts'),
  
  checkBlockedMeters: () =>
    api.post('/alerts/check-blocked-meters'),
  
  checkHighConsumption: (threshold = 100) =>
    api.post('/alerts/check-high-consumption', null, { params: { threshold_kwh: threshold } }),
  
  checkPendingTransactions: () =>
    api.post('/alerts/check-pending-transactions'),
  
  // Vérification complète
  checkAll: () => api.post('/alerts/check-all'),
  
  // Résumé quotidien
  sendDailySummary: () => api.post('/alerts/send-daily-summary'),
};

export const importExportService = {
  // Clients
 exportClients: () => api.get('/import-export/clients/export', { 
    responseType: 'blob',
    headers: {
      'Accept': 'text/csv'
    }
  }),
  importClients: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/import-export/clients/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  // Compteurs
  exportMeters: () => api.get('/import-export/meters/export', { responseType: 'blob' }),
  importMeters: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/import-export/meters/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  
  
  // Transactions CSV
  exportTransactions: (startDate, endDate) => api.get('/import-export/transactions/export', {
    params: { start_date: startDate, end_date: endDate },
    responseType: 'blob'
  }),
  // Transactions PDF
  exportTransactionsPDF: (startDate, endDate) => api.get('/import-export/transactions/export-pdf', {
    params: { start_date: startDate, end_date: endDate },
    responseType: 'blob'
  }),
};
// Ajouter ce service dans votre fichier services/api.js
export const securityService = {
  // 2FA
  enable2FA: () => api.post('/security/2fa/enable'),
  verify2FA: (code) => api.post('/security/2fa/verify', { code }),
  disable2FA: (code) => api.post('/security/2fa/disable', { code }),
  get2FAStatus: () => api.get('/security/2fa/status'),
  
  // Sessions
  getSessions: () => api.get('/security/sessions'),
  revokeSession: (sessionId) => api.delete(`/security/sessions/${sessionId}`),
  
  // API Keys
  getApiKeys: () => api.get('/security/api-keys'),
  createApiKey: (name, expiresDays = 365) => api.post('/security/api-keys', { name, expires_days: expiresDays }),
  revokeApiKey: (keyId) => api.delete(`/security/api-keys/${keyId}`)
};

export const contractsService = {
  nextNumber: (prefix = 'ZCH') =>
    api.get('/contracts/next-number', { params: { prefix } }),
  generate: (payload) =>
    api.post('/contracts/generate', payload, { responseType: 'blob' }),
  getAll: (params = {}) => api.get('/contracts', { params }),
  getById: (contractId) => api.get(`/contracts/${contractId}`),
  update: (contractId, payload) =>
    api.put(`/contracts/${contractId}`, payload, { responseType: 'blob' }),
  remove: (contractId) => api.delete(`/contracts/${contractId}`),
  reprint: (contractId) =>
    api.get(`/contracts/${contractId}/reprint`, { responseType: 'blob' }),
};
 
export const powerPlantService = {
  getAll: (params = {}) => api.get('/power-plants/', { params }),
  getVillages: () => api.get('/power-plants/villages'),
  getStats: () => api.get('/power-plants/stats'),
  createOrUpdate: (data) => api.post('/power-plants/', data),
  update: (id, data) => api.put(`/power-plants/${id}`, data),
  delete: (id) => api.delete(`/power-plants/${id}`),

  // ✅ Suppression définitive d'un village de la liste (même avec compteurs)
  deleteVillage: (address) => api.delete('/power-plants/villages', { params: { address } }),
  // ✅ Villages supprimés, proposés dans « Ajouter » pour les ré-ajouter
  getExcluded: () => api.get('/power-plants/excluded'),

  exportXlsx: (search, installationType) => api.get('/power-plants/export', {
    params: { format: 'xlsx', search: search || undefined, installation_type: installationType || undefined },
    responseType: 'blob',
  }),
  exportPdf: (search, installationType) => api.get('/power-plants/export', {
    params: { format: 'pdf', search: search || undefined, installation_type: installationType || undefined },
    responseType: 'blob',
  }),
};
// ============================================
// ✅ GOMELONG — CONTRÔLE À DISTANCE (eau + électricité)
// Backend : routers/gomelong_remote.py → /api/gomelong-remote
// ============================================
export const gomelongRemoteService = {
  health: () => api.get('/gomelong-remote/health'),
  getMeter: (meterId) => api.get(`/gomelong-remote/meter/${meterId}`),            // fiche locale (rapide)
  getMeterRemote: (meterId) => api.get(`/gomelong-remote/meter/${meterId}/remote`), // état GOMELONG
  setCollector: (meterId, collectorId) =>
    api.put(`/gomelong-remote/meter/${meterId}/collector`, { collector_id: collectorId || null }),
  getHistory: (meterId, limit = 50) => api.get(`/gomelong-remote/history/${meterId}`, { params: { limit } }),
  getTask: (taskId) => api.get(`/gomelong-remote/task/${taskId}`),
  getCollector: (collectorId, kind = 'collector') =>
    api.get(`/gomelong-remote/collector/${collectorId}`, { params: { kind } }),

  // 💧 Eau
  waterValve: (meterId, action, reason) =>
    api.post(`/gomelong-remote/water/valve/${meterId}`, null, { params: { action, reason } }),
  waterClear: (meterId, kind = 'credit') =>
    api.post(`/gomelong-remote/water/clear/${meterId}`, null, { params: { kind } }),
  waterSendToken: (meterId, token) =>
    api.post(`/gomelong-remote/water/send-token/${meterId}`, null, { params: { token } }),
  waterData: (meterId, day) => api.get(`/gomelong-remote/water/data/${meterId}`, { params: { day } }),
  waterPurchases: (meterId, params = {}) => api.get(`/gomelong-remote/water/purchases/${meterId}`, { params }),
  waterRegister: (meterId, params = {}) => api.post(`/gomelong-remote/water/register/${meterId}`, null, { params }),

  // ⚡ Électricité (plateforme Intelligent)
  elecRelay: (meterId, action, reason) =>
    api.post(`/gomelong-remote/elec/relay/${meterId}`, null, { params: { action, reason } }),
  elecRead: (meterId, readType = 10) =>
    api.post(`/gomelong-remote/elec/read/${meterId}`, null, { params: { read_type: readType } }),
  elecSendToken: (meterId, token, tokenType = 12) =>
    api.post(`/gomelong-remote/elec/send-token/${meterId}`, null, { params: { token, token_type: tokenType } }),
  elecRegister: (meterId, params = {}) => api.post(`/gomelong-remote/elec/register/${meterId}`, null, { params }),
  // 📋 Fiche STS du compteur (client, type d'usage, clé SGC)
  getContract: (meterId) => api.get(`/gomelong-remote/contract/${meterId}`),

  stsClear: (meterId, kind = 'credit') =>
    api.post(`/gomelong-remote/sts/clear/${meterId}`, null, { params: { kind } }),
  stsPowerLimit: (meterId, watts) =>
    api.post(`/gomelong-remote/sts/power-limit/${meterId}`, null, { params: { watts } }),
};